import logos from '../../../../assets/images/logos';
import {
  StyledContainer,
  StyledTypography,
  StyledLogoContainer,
  StyledLogo,
} from './styled';

const ContentBlock = () => {
  return (
    <StyledContainer>
      <StyledTypography>
        Publish music everywhere, no takedowns
      </StyledTypography>
      <StyledLogoContainer>
        {Object.entries(logos).map(([key, src]) => (
          <StyledLogo key={key} src={src} alt={key} />
        ))}
      </StyledLogoContainer>
    </StyledContainer>
  );
};

export default ContentBlock;
